import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import moment from "moment";
import DataTable from "react-data-table-component";
import { NotificationManager } from "react-notifications";
import { makeStyles } from "@mui/styles";
import LinearProgress from "@mui/material/LinearProgress";
import Tooltip from "@mui/material/Tooltip";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import { postChartV2 } from "services/ConfigServices";
import useChartsTable from "./useChartsTable.js";
import CustomDeleteButton from "components/CustomDeleteButton/CustomDeleteButton.js";
import UserService from "services/UserService";
import Button from "components/CustomButtons/Button.js";
import styled from "styled-components";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import { charttext } from "variables/chart";
import { typesdata, granularitydata } from "variables/lists/charts";
import Chip from "@mui/material/Chip";
import Dialog from "@mui/material/Dialog";
import { withStyles } from "@mui/styles";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import CustomDialogTitle from "components/Dialog/CustomDialogTitle.js";
import { statusData } from "variables/MBM/lists/campaign"

import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import StopIcon from '@mui/icons-material/Stop';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import { charttypeselectData } from "variables/lists/vues.js";
import ChartDialogV2 from "./ChartDialogV2";
import { realestatedata } from "variables/lists/charts";
import { deleteChartV2 } from "services/ConfigServices.js";

const GroupCell = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

const Container = styled.div`
  border-bottom: 0.5px solid rgba(0, 0, 0, 0.15);
  border-top: 4px solid rgba(255, 255, 255, 1);
  background-color: white;
  margin-top: -0.5px;
`;

const ExpandableContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0.5rem 4rem 2rem;
`;
const ExpandableElement = styled.div`
  display: flex;
  flex-direction: row;
  margin-left: ${(props) => props.marginleft};
`;

const ElementTitle = styled.div`
  font-weight: 600;
  font-size: 12px;
  font-family: "Source Sans Pro",sans-serif;
`;

const ElementData = styled.div`
  margin-left: 4px;
  font-weight: 400;
  font-size: 12px;
  font-family: "Source Sans Pro",sans-serif;
`;

const NoData = styled.p`
  font-size: 14px;
  font-weight: 600;
  margin-top: 20px;
  opacity: 1;
`;


const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '8px',
  },
}))(MuiDialogActions);

const useStyles = makeStyles(styles);

const RTCampaigns = () => {
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const charts_admin = permis.includes("charts_admin");
  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup, groupInfoListById } = appContext;
  const [open, setOpen] = useState(false);
  const [openManagement, setOpenManagement] = useState(false);
  const [openDuplicate, setOpenDuplicate] = useState(false);
  const [currentCharts, setCurrentChart] = useState(null);
  const { gridState, refetch, setCharts, setLoading, indicatordata, pointdata, avalaibleDico } = useChartsTable();


  let dataCharts = gridState.data;

  

  const classes = useStyles();

  const columns = [
    {
      name: charttext.name,
      selector: (row) => row.parameters.name,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => row.parameters.name,
    },
    {
      name: charttext.type,
      selector: (row) => row.parameters.type,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => typesdata.find((x) => x.id == row.parameters.type)?.name || ""
    },
    {
      name: charttext.granularity,
      selector: (row) => row.parameters.xaxistimetick,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => row.parameters.xaxistimetick ? (granularitydata.find((x) => x.id == row.parameters.xaxistimetick)?.name || "") : charttext.notime
    },
    {
      name: charttext.visibility,
      selector: (row) => row.accountid,
      sortable: true,
      cell: (row) => (
        <GroupCell>
          <div>{row.accountid ? groupInfoListById["" + row.accountid] : charttext.all}</div>
        </GroupCell>
      ),
      // width: "8rem",
    },
    {
      name: "",
      sortable: false,
      width: "12rem",
      // eslint-disable-next-line react/button-has-type
      // eslint-disable-next-line react/display-name
      cell: (row) => (
        <>
          <div className="actions-right">
            {charts_admin && (
              <>
                <Tooltip title="Editer le graphique">
                  <Button
                    onClick={editChart(row)}
                    color={"warning"}
                    className={classes.actionButton}
                  >
                    <EditIcon fontSize="large" />
                  </Button>
                </Tooltip>
                <Tooltip title="Dupliquer le graphique">
                  <Button
                    onClick={duplicateChart(row)}
                    color={"info"}
                    className={classes.actionButton}
                  >
                    <FileCopyIcon fontSize="large" />
                  </Button>
                </Tooltip>
                <Tooltip title="Supprimer le graphique">
                  <CustomDeleteButton
                    deleteTitle={"Suppression du graphique"}
                    deleteSubTitle={`Êtes-vous sûr de vouloir supprimer le graphique ${row.parameters.name}?`}
                    handleSupprimer={deleteChartFunction(row)}
                  />
                </Tooltip>
              </>
            )}
          </div>
        </>
      ),
    },
  ];

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleEditClose = () => {
    setOpen(false);
  };

  const handleClickManagementOpen = () => {
    setOpenManagement(true);
  };
  const handleEditManagementClose = () => {
    setOpenManagement(false);
  };

  const handleClickDuplicateOpen = () => {
    setOpenDuplicate(true);
  };
  const handleDuplicateClose = () => {
    setOpenDuplicate(false);
  };

  const editChart = (row) => async () => {
    let obj = dataCharts.find((o) => o.id === row.id);
    if (obj) {
      setCurrentChart(obj);
      handleClickOpen();
    }
  }

  const duplicateChart = (row) => async () => {
    let obj = dataCharts.find((o) => o.id === row.id);
    if (obj) {
      let newchart = {...obj};
      newchart.parameters.name = "(Copie) "+newchart.parameters.name;     
      axios
        .post(
          postChartV2(),
          newchart
          ,
          {
            headers: {
              Authorization: `Bearer ${UserService.getToken()}`,
              'Content-Type': "application/json; charset=utf-8",
            },
          }
        )
        .then((res) => {
          if (res.status == 200) {
            NotificationManager.success("Graphique créé");
            refetch();
          } else NotificationManager.error("Une erreur est survenue");
        })
        .catch((error) => {
          NotificationManager.error("Une erreur est survenue");
          setLoading(false);
        });
    }
  }

  const deleteChartFunction = (row) => async () => {
    let obj = dataCharts.find((o) => o.id === row.id);
    let idSelected = obj.id;
    let selected = [];
    selected.push(idSelected);
    let url = deleteChartV2(idSelected);
    axios
      .delete(url,
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        })
      .then((res) => {
        if (res.status == 200) {
          setNotification(
            "success",
            `Le graphique a été supprimée`
          );
          refetch();
        } else setNotification("error", "Une erreur est survenue");
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
      });
  };


  const setNotification = (status, text) => {
    if (status === "success") {
      NotificationManager.success(text);
    } else {
      NotificationManager.error(text);
    }
  };

  const handleSelectedRowsChange = (selection) => {
    setCharts(selection.selectedRows);
  };


  return (
    <>
      <DataTable
          paginationRowsPerPageOptions={[10,20,30,50,100]}
        noDataComponent={<NoData>Aucun graphique à afficher</NoData>}
        noHeader={true}
        columns={columns}
        persistTableHead
        pagination
        subHeader
        highlightOnHover
        pointerOnHover
        onRowClicked={(row) => {
          let obj = dataCharts.find((o) => o.id === row.id);
          if (obj && charts_admin) {
            setCurrentChart(obj);
            handleClickOpen();
          }
        }
        }
        onSelectedRowsChange={handleSelectedRowsChange}
        selectableRows={false}
        progressPending={gridState.loading}
        progressComponent={<LinearProgress />}
        expandableRowDisabled={(row) => row.disabled}
        paginationComponentOptions={{
          noRowsPerPage: false,
          rowsPerPageText: "Lignes par page",
          rangeSeparatorText: "sur",
          selectAllRowsItem: false,
          selectAllRowsItemText: "Selectionner toutes les lignes",
        }}
        {...gridState}
      />
      <Dialog
        onClose={handleEditClose}
        aria-labelledby="edituser-dialog-title"
        fullWidth="true"
        maxWidth="lg"
        open={open}
      >

        <ChartDialogV2
          currentchart={currentCharts}
          closeModal={handleEditClose}
          refetch={refetch}
          setLoading={setLoading}
          indicatordata={indicatordata}
          pointdata={pointdata}
          realestatedata={realestatedata}
          avalaibleDico={avalaibleDico}
        />

      </Dialog>
      {/* <Dialog
        onClose={handleEditManagementClose}
        aria-labelledby="edituser-dialog-title"
        fullWidth="true"
        maxWidth="lg"
        open={openManagement}
      >
        <CustomDialogTitle id="customized-dialog-title" onClose={handleEditManagementClose}>
          {'Gestion de la campagne ' + currentCampaign?.parameters?.general?.name}
        </CustomDialogTitle>
        <DialogContent dividers>
          <CampaignManagementDialog
            currentCampaign={currentCampaign}
            closeModal={handleEditManagementClose}
            refetch={refetch}
          />
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>
      <Dialog
        onClose={handleDuplicateClose}
        aria-labelledby="edituser-dialog-title"
        fullWidth="true"
        maxWidth="sm"
        open={openDuplicate}
      >
        <CustomDialogTitle id="customized-dialog-title" onClose={handleDuplicateClose}>
          {'Dupliquer la campagne ' + currentCampaign?.parameters?.general?.name}
        </CustomDialogTitle>
        <DialogContent dividers>
          <CampaignDuplicateDialog
            currentCampaign={currentCampaign}
            closeModal={handleDuplicateClose}
            refetch={refetch}
          />
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog> */}
    </>
  );
};

export default RTCampaigns;
